module.exports = __webpack_public_path__ + "static/media/CQY_9.15_IT_RGB.ce4f4412.png";